module.exports = __webpack_public_path__ + "img/moto.15e7c971.svg";